export default "__VITE_ASSET__CXjyhBto__"